import React from "react";
import BeneficariesView from "../BeneficariesView/BeneficariesView";
import Icon1 from "../../images/gbrFarmerBenefits/pay-per-click.svg";

// Component representing the role of a Plant Operator / Worker
const PlantOperator = () => {
  // Key features available to Plant Operators
  const features = [
    {
      image: Icon1,
      title: "Automated Work Scheduling",
      bodycopy:
        "Digitized shift planning and task assignments for efficient workflow management.",
    },
    {
      image: Icon1,
      title: "Real-Time Process Guidance",
      bodycopy:
        "Step-by-step operational instructions for machinery handling and production tasks.",
    },
    {
      image: Icon1,
      title: "Safety Compliance & Alerts",
      bodycopy:
        "Automated safety checks, hazard notifications, and emergency response systems.",
    },
    {
      image: Icon1,
      title: "Performance & Attendance Tracking",
      bodycopy:
        "Digital monitoring of work hours, task completion, and efficiency for incentives.",
    },
    {
      image: Icon1,
      title: "Training & Skill Development",
      bodycopy:
        "Continuous learning modules and certifications for career growth and upskilling.",
    },
  ];

  // Benefits of adopting digital tools for Plant Operators
  const benefits = [
    {
      image: Icon1,
      title: "Enhanced Work Efficiency",
      bodycopy:
        "Automated scheduling and digital guidance reduce errors and improve productivity.",
    },
    {
      image: Icon1,
      title: "Higher Earnings & Incentives",
      bodycopy:
        "Performance-based rewards and transparent wage tracking boost income opportunities.",
    },
    {
      image: Icon1,
      title: "Improved Workplace Safety",
      bodycopy:
        "Real-time alerts and compliance tracking ensure a secure work environment.",
    },
    {
      image: Icon1,
      title: "Career Growth Opportunities",
      bodycopy:
        "Access to training programs helps workers upgrade skills and move up the career ladder.",
    },
    {
      image: Icon1,
      title: "Reduced Downtime & Stress",
      bodycopy:
        "Predictive maintenance and streamlined operations minimize disruptions and workload stress.",
    },
  ];

  return (
    <>
      {/* Component rendering banner, features and benefits */}
      <BeneficariesView
        title="Plant Operator / Worker"
        features={features}
        benefits={benefits}
      />
    </>
  );
};

export default PlantOperator;
